
import { Icon } from "@chakra-ui/react";
import {
  MdPerson
} from "react-icons/md";

import { BsCheck2All } from "react-icons/bs";
import { GiAbstract065, GiChoice } from "react-icons/gi";
import { GoZap } from "react-icons/go";
import { WiMoonAltWaningGibbous3 } from "react-icons/wi";


// Admin Imports
import ControlPannel from "views/admin/dao";
import ControlPannelVerification from "views/admin/dao-verif";
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import Staking from "views/admin/staking";
import Unlock from "views/admin/unlock";

export const MOON_MISSION_ROUTE = {
  name: "Board",
  layout: "/admin",
  path: "/board",
  icon: <Icon as={GiAbstract065} width='20px' height='20px' />,
  component: MainDashboard,
  authenticatedRoute: false,
}

export const UNLOCK_ROUTE = {
  name: "Connect",
  layout: "/admin",
  path: "/unlock",
  icon: (
    <Icon as={GoZap} width='20px' height='20px' color='inherit' />
  ),
  authenticatedRoute: false,
  isAdmin: false,
  component: Unlock,
}
export const ADMIN_ROUTE = {
  name: "Governance Admin",
  layout: "/admin",
  path: "/admin-governance",
  icon: (
    <Icon
      as={BsCheck2All}
      width='20px'
      height='20px'
      color='inherit'
    />
  ),
  component: ControlPannelVerification,
  authenticatedRoute: true,
  isAdmin: true,
}

export const routes = [
  MOON_MISSION_ROUTE,
  {
    name: "Governance",
    layout: "/admin",
    path: "/governance",
    icon: (
      <Icon
        as={GiChoice}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: ControlPannel,
    authenticatedRoute: false,
    isAdmin: false,
  },
  ADMIN_ROUTE,
  {
    name: "Time-Staking",
    layout: "/admin",
    path: "/staking",
    icon: <Icon as={WiMoonAltWaningGibbous3} width='20px' height='20px' />,
    component: Staking,
    authenticatedRoute: true,
    isAdmin: false,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "/profile",
    icon: <Icon as={MdPerson} width='20px' height='20px' />,
    component: Profile,
    authenticatedRoute: true,
    isAdmin: false,
  },
  UNLOCK_ROUTE
];
